import {
  bindActionCreators,
  PayloadAction,
  ActionCreator,
} from "@reduxjs/toolkit";

export function setter<P>(name: keyof P) {
  return (state, action: PayloadAction<P[keyof P]>) => {
    state[name] = action.payload;
  };
}

function pick<T, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> {
  const ret: any = {};
  keys.forEach((key) => {
    ret[key] = obj[key];
  });
  return ret;
}

export function createActionDispatchers<
  T extends Record<string, ActionCreator<unknown>>,
  K extends keyof T,
  P extends Record<string, ActionCreator<unknown>>
>(actions: T, properties: K[], pureActions: P) {
  const sliaceActionsSubset = pick(actions, properties);
  return (dispatch) =>
    bindActionCreators({ ...sliaceActionsSubset, ...pureActions }, dispatch);
}
